import { CustomWallpaper } from '@wetransfer/ad-sdk';

import { userHasPaidTier } from '@wetransfer/transfer/helper/user';
import { State } from '@wetransfer/transfer/store/types';

export const isMicroFrontendAvailable = (): boolean => {
  return Boolean(window.AdTech?.wallpaper);
};

export const getChannelWallpapers = ({
  channelWallpapers,
  accountWallpapers,
  user,
}: Pick<State, 'user'> & {
  channelWallpapers: State['channel']['wallpapers'];
  accountWallpapers: State['account']['wallpapers'];
}): CustomWallpaper[] => {
  if (channelWallpapers.length) {
    return channelWallpapers.map((wallpaper) => {
      return {
        format: wallpaper.wallpaperType,
        src: wallpaper.src,
        resizedSrcSmall: wallpaper.resizedSrcSmall,
        resizedSrcMedium: wallpaper.resizedSrcMedium,
        resizedSrcLarge: wallpaper.resizedSrcLarge,
        href: wallpaper.href,
        title: wallpaper.title,
      };
    });
  }

  // if the channel has no wallpaper and the user has a paid tier, use account wallpapers in current user channel (same data but different format than channel wallpapers)
  // Removal proposal: https://wetransfer.atlassian.net/browse/ADT-784
  if (userHasPaidTier(user)) {
    return accountWallpapers.map(({ wallpaper_type, asset_url }) => ({
      format: wallpaper_type,
      src: asset_url,
    }));
  }

  return [];
};
